import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent, LoadingController, Platform } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { DepositMainLabels } from 'src/app/interfaces/deposit-main-labels';
import { DepositMainModel } from 'src/app/models/deposit-models';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { DEPOSIT_PATTERN } from 'src/app/services/customFormValidators';
import { MenuStateService } from 'src/app/services/menu-state/menu-state.service';
import { ResponsibleGamingService } from 'src/app/services/responsible-gaming-service/responsible-gaming.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
declare function returnPNM(): any;
@Component({
  selector: 'app-deposit-main',
  templateUrl: './deposit-main.component.html',
  styleUrls: ['./deposit-main.component.scss'],
})
export class DepositMainComponent implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;

  @Input() public navigateBackPage: any;

  public paymentVendors: any = [];
  public labels: DepositMainLabels;
  public loading: any;
  public amount: AbstractControl;
  public depositForm: FormGroup;
  public PNM: any; //be careful not use before it's been inited on submission!
  public bonusCode: string;
  public currentTransactionID: string;
  public showAmountError: boolean = false;
  public showAmountTooSmallError: boolean = false;
  public defaultAmounts: any = [];

  constructor(
    public cashierService: CashierService,
    public cashierContentService: CashierContentService,
    public navigator: Navigator,
    public utils: UtilsService,
    public loadingController: LoadingController,
    public menuStateService: MenuStateService,
    private config: ConfigService,
    private platform: Platform,
    private responsibleGamingProvider: ResponsibleGamingService
  ) {
    this.labels = new DepositMainModel();
    this.showLoading();
  }


  public onAmountSelected(data) {
    return this.depositForm.get('amount').setValue(data);
  }

  ngOnInit(): void {
    this.depositForm = new FormGroup({
      amount: new FormControl({ value: '', disabled: false }, { validators: [Validators.pattern(DEPOSIT_PATTERN), Validators.required], updateOn: 'change' }),
    });
    this.amount = this.depositForm.get('amount');
    this.cashierContentService.bonusOfferValue.subscribe(res => this.bonusCode = res);
    this.defaultAmounts = (this.config.getConfig().FEATURE_DEPOSIT_MAIN_DEFAULT_PRESETS || "25,50,100").split(",");
  }

  ionViewWillEnter() {
    this.getVendorData();
  }

  ngAfterViewInit() {
    this.cashierContentService.getPageConfig('main').then((response: DepositMainLabels) => {
      this.labels = response;
    });
  }

  async showLoading() {
    this.loading = await this.loadingController.create({
      message: 'Loading...',
      duration: 3000
    });

    this.loading.present();
  }

  onBack = () => {
    console.log("test?", this.navigateBackPage);
    if (
      !this.navigateBackPage
      || this.navigateBackPage == "default"
      || this.navigateBackPage == "DepositMainComponent") return this.navigator.back();
    if (
      this.navigateBackPage == "navbar"
      || this.navigateBackPage == "navbar-text"
    ) return this.navigator.toLobby();
    if (this.navigateBackPage == "sidemenu") {
      this.navigator.dismissAll();
      return this.menuStateService.openSidemenu("main-menu");
    }
    if (this.navigateBackPage == "MyTransactionMethodsComponent" || this.navigateBackPage == "AccountBalanceComponent") return this.navigator.navigateTo(this.navigateBackPage)
    return this.navigator.navigateTo(this.navigateBackPage, { multipleModals: true });
  }

  public getVendorData(): any {
    return this.cashierService.getActiveTypesCategories({ include_types: false }).subscribe((response: any) => {
      if (response.result) {
        let vendors = response.payload;
        this.paymentVendors = vendors.filter(vendor => {
          if (vendor.code === 'VVAP') {
            return this.platform.is('ios');
          }
          return true;
        });
        this.loading.dismiss();
      }
    }, error => {
      this.content.scrollToTop(10)
      this.loading.dismiss();
      console.error("Vendor Data Error", error);
    });
  }

  public goToPaymentPage(pageName) {
    this.showAmountError = false;
    this.showAmountTooSmallError = false;
    // Old Code
    // const pageToNavigate = this.cashierContentService.getVendorPage(pageName);
    // return this.navigator.navigateTo(pageToNavigate, { multipleModals: true }, {navigateBackPage: "DepositMainComponent", pageCode: pageName}); 
    // Old Code end


    const depositFormObj = this.depositForm.value;
    depositFormObj.depositMethod = pageName;
    depositFormObj.amount = parseFloat(this.depositForm.get('amount').value).toFixed(2);
    depositFormObj.bonusCode = this.bonusCode;
    depositFormObj.payment_type_code = pageName;
    depositFormObj.currency_code = this.cashierService.customer.preferredCurrency.currencyCode;


    if (depositFormObj.depositMethod === "CAGE") {
      return this.navigator.navigateTo('DepositCageComponent', { multipleModals: true }, { navigateBackPage: "DepositMainComponent", pageCode: pageName });
    } else {
      if ((this.amount.value !== null && this.amount.value !== "" && this.amount.value >= 10) || depositFormObj.depositMethod == "CASH" ) {
        this.navigator.navigateTo('DepositPaynearmeV2Component', {}, { depositFormObj: depositFormObj })
      } else if (this.amount.value < 10) {
        this.showAmountTooSmallError = true;
      } else {
        this.showAmountError = true;
      }
    }
  }

  public getPaymentImage(name: string): string {
    let imageUrl: string;
    imageUrl = `url(${this.utils.getDepositCDNAAsset(name)})`;
    return imageUrl;
  }

}
